<div *ngIf="src" #mainElement>
  <iframe class="center" [width]="width + 'px'" [height]="height + 'px'" [src]="src" [title]="'Youtube'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen></iframe>
</div>